import React from 'react';
import { Radio } from '../Checkbox';
import { fieldMaxWidth, StyledFieldSet, StyledLegend } from '../Field/Field.styled';
import { RequiredLabel } from '../Label/Label';
import { Tooltip } from '../Tooltip';
import { StyledMultipleChoice } from './Select.styled';
export function MultipleChoice(props) {
  var name = "multiplechoice".concat(Math.random());
  return /*#__PURE__*/React.createElement("div", null, props.options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(StyledMultipleChoice, {
      key: index
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: props.value === option.value,
      disabled: props.disabled || option.disabled,
      onChange: function onChange() {
        return props.onChange(option.value);
      },
      name: name
    }, option.label || option.value), option.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, option.tooltip));
  }));
}
export function MultipleChoiceField(props) {
  var fieldsetRef = React.useRef(null);
  React.useEffect(function () {
    if (props.focused) {
      var _fieldsetRef$current, _fieldsetRef$current2;
      (_fieldsetRef$current = fieldsetRef.current) === null || _fieldsetRef$current === void 0 ? void 0 : _fieldsetRef$current.scrollIntoView();
      (_fieldsetRef$current2 = fieldsetRef.current) === null || _fieldsetRef$current2 === void 0 ? void 0 : _fieldsetRef$current2.focus();
    }
  }, [props.focused]);
  var maxWidth = props.maxWidth || fieldMaxWidth;
  return /*#__PURE__*/React.createElement(StyledFieldSet, {
    ref: fieldsetRef,
    disabled: props.disabled,
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement(StyledLegend, {
    as: "legend"
  }, props.label, props.required && /*#__PURE__*/React.createElement(RequiredLabel, null), props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip)), /*#__PURE__*/React.createElement(MultipleChoice, props));
}